import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { Divider } from '../divider';

const styles = cssMap({
	menuContainer: {
		width: '100%',
		display: 'inline-flex',
		paddingTop: token('space.100'),
		paddingRight: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.100'),
		flexDirection: 'column',
		alignItems: 'center',
		gap: token('space.025'),
		backgroundColor: token('elevation.surface'),
	},
	menuTextContainer: {
		display: 'flex',
		paddingTop: token('space.100'),
		paddingRight: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.100'),
		alignItems: 'center',
		gap: token('space.150'),
		alignSelf: 'stretch',
	},
	menuText: {
		font: token('font.heading.xxsmall'),
		color: token('color.text.subtlest'),
	},
});

export type MenuItemComponent = React.ReactNode;

export interface MenuSection {
	title?: string;
	items: MenuItemComponent[];
}

export interface ChatHeaderMenuListProps {
	sections: MenuSection[];
}

export const ChatHeaderMenuList = ({ sections }: ChatHeaderMenuListProps): React.JSX.Element => (
	<Box xcss={styles.menuContainer}>
		{sections.map(
			(section, sectionIndex) =>
				section.items.length > 0 && (
					<React.Fragment key={sectionIndex}>
						{section.title && (
							<Box xcss={styles.menuTextContainer}>
								{/*
								 * Intentionally not an `h2` element. This menu can render inside
								 * an editor's content area (see `shouldRenderToParent`), where
								 * the editor's `& h2` UGC typography rule would override the
								 * menu style. `role`/`aria-level` keep the heading semantics.
								 */}
								<Box role="heading" aria-level={2} xcss={styles.menuText}>
									{section.title}
								</Box>
							</Box>
						)}
						{section.items}
						{sectionIndex !== sections.length - 1 && <Divider isThin withMargin />}
					</React.Fragment>
				),
		)}
	</Box>
);
